// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.baseButton[data-v-4af0aa13] {\n  display: inline-block;\n  min-width: fit-content; /* Chrome and Safari */\n  min-width: -moz-max-content; /* Firefox */\n  width: 10px;\n  margin: 0.5em;\n  padding: 1em 2em;\n  background: #fff;\n  border: 1px solid lightgray;\n  border-radius: 3px;\n  color: gray;\n  font-size: 1em;\n  line-height: 1;\n  transition: 0.3s;\n}\n.baseButton[data-v-4af0aa13]:hover {\n  background: #e8e5e5;\n  color: #555;\n}\n", ""]);
// Exports
module.exports = exports;
